import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { Button } from "@/components/Button";
import { PageLoading } from "@/components/PageLoading";

export default function YouthRegisterLayout() {
  return (
    <div className="container">
      <div className="flex items-center justify-between py-6">
        <div>
          <h1 className="mb-2 text-2xl font-medium text-text-primary">
            Yoshlar daftari
          </h1>
          <p className="text-sm font-normal text-text-tertiary">
            Bu bo’lim orqali siz “Ysohlar daftari”ga kiritilgan yoshlar haqida
            ma’lumot olishingiz mumkin
          </p>
        </div>
        <Button variant="primary">Kelib tushgan arizalar</Button>
      </div>
      <Suspense fallback={<PageLoading />}>
        <Outlet />
      </Suspense>
    </div>
  );
}
